module.exports = __webpack_public_path__ + "img/client-5.75716220.png";